import React from 'react';
import { FileText, AlertCircle, CheckCircle, Clock, ExternalLink } from 'lucide-react';
import { SalespersonRequirementTable, BrokerRequirementTable } from '../components/RequirementTables';
export function LicenseInformation() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-990">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-991">
        {/* Page Header */}
        <div className="mb-12" data-id="element-992">
          <div className="flex items-center justify-center mb-6" data-id="element-993">
            <FileText className="w-12 h-12 text-brand-purple-600 mr-4" data-id="element-994" />
            <h1 className="text-4xl font-bold text-gray-900 text-center" data-id="element-995">
              LICENSE INFORMATION AND REQUIREMENTS
            </h1>
          </div>
        </div>

        {/* Quick Links */}
        <div className="mb-12 bg-brand-purple-50 rounded-lg p-6 border-2 border-brand-purple-200" data-id="element-996">
          <p className="text-lg text-gray-900 mb-4" data-id="element-997">
            <strong data-id="element-998">License and Course Information:</strong>{' '}
            <a href="/Products" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-999">
              Click here to see On-Demand class offerings
            </a>{' '}
            or{' '}
            <a href="/Login" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-1000">
              Log In
            </a>
          </p>
        </div>

        {/* Key Information Bullets */}
        <div className="mb-12 space-y-4" data-id="element-1001">
          <div className="flex items-start" data-id="element-1002">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-1003" />
            <p className="text-base text-gray-700" data-id="element-1004">
              All our CE classes are approved for renewal credit with the
              Arizona Department of Real Estate School #S06-0002
            </p>
          </div>
          <div className="flex items-start" data-id="element-1005">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-1006" />
            <p className="text-base text-gray-700" data-id="element-1007">
              Our classes are text-based so there is no need to worry about
              audio or video issues.
            </p>
          </div>
          <div className="flex items-start" data-id="element-1008">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-1009" />
            <p className="text-base text-gray-700" data-id="element-1010">
              The final exam will repeat the quiz questions and you will need to
              achieve at least 80% score to pass. Print certificates from your
              Class History folder.
            </p>
          </div>
          <div className="flex items-start" data-id="element-1011">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-1012" />
            <p className="text-base text-gray-700" data-id="element-1013">
              When a class is completed you can print your certificate
              immediately (or later from your Class History folder on your
              Dashboard).
            </p>
          </div>
          <div className="flex items-start" data-id="element-1014">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-1015" />
            <p className="text-base text-gray-700" data-id="element-1016">
              To be paperless: when you click to print your certificate, a PDF
              will be downloaded to your device.
            </p>
          </div>
          <div className="flex items-start" data-id="element-1017">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-1018" />
            <p className="text-base text-gray-700" data-id="element-1019">
              The Arizona Department of Real Estate:{' '}
              <a href="https://azre.gov/all-adre-resources/fees" target="_blank" rel="noopener noreferrer" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-1020">
                Fee Schedule
              </a>
            </p>
          </div>
          <div className="flex items-start" data-id="element-1021">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-1022" />
            <p className="text-base text-gray-700" data-id="element-1023">
              You must complete and report all your CE credits by midnight of
              the last calendar day of the month that your license expires (that
              includes Saturdays, Sundays and Holidays).
            </p>
          </div>
          <div className="flex items-start" data-id="element-1024">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-1025" />
            <p className="text-base text-gray-700" data-id="element-1026">
              You may pay for and renew your license up to 90 days prior to
              expiration.
            </p>
          </div>
          <div className="flex items-start" data-id="element-1027">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-1028" />
            <p className="text-base text-gray-700" data-id="element-1029">
              You are responsible for reporting your hours to ADRE and keeping
              your certificates for 5 years.{' '}
              <a href="/How_To_Add_CE_Classes" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-1030">
                Click here
              </a>{' '}
              for directions and link to ADRE Licensee Login.
            </p>
          </div>
        </div>

        {/* CE Hours REQUIREMENTS */}
        <div className="mb-12" data-id="element-1031">
          <h2 className="text-3xl font-bold text-brand-purple-900 mb-6" data-id="element-1032">
            CE Hours REQUIREMENTS
          </h2>

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg mb-8" data-id="element-1033">
            <p className="text-base text-gray-800" data-id="element-1034">
              <strong data-id="element-1035">FIRST TIME RENEWAL:</strong> Be sure to report class
              information from your Pre-Licensing Contract Writing class into
              your account at ADRE. Once done, you will only need 18 additional
              CE hours.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 items-start" data-id="element-1036">
            <SalespersonRequirementTable data-id="element-1037" />
            <BrokerRequirementTable data-id="element-1038" />
          </div>

          <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg mt-4" data-id="element-1039">
            <p className="text-base text-gray-800 font-medium" data-id="element-1040">
              For your remaining 3 hours you may choose any credit type,
              providing you do not duplicate any course title that you have
              already taken within the renewal period. Different class name =
              Different course number.
            </p>
          </div>
        </div>

        {/* Important Notes */}
        <div className="mb-12 space-y-6" data-id="element-1041">
          <div className="bg-brand-purple-50 border-l-4 border-brand-purple-400 p-6 rounded-lg" data-id="element-1042">
            <p className="text-base text-gray-800" data-id="element-1043">
              ADRE allows you to renew your license online. To do so, log on at{' '}
              <a href="https://az.gov/webapp/dre/" target="_blank" rel="noopener noreferrer" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-1044">
                https://az.gov/webapp/dre/
              </a>{' '}
              where you will be able to pay for and renew your license.
            </p>
          </div>
        </div>
      </div>
    </div>;
}